import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";
import { ChannelsBalanceReportEntry } from "@/model/data/channelsBalance/ChannelsBalanceReportEntry";
import { UsersBalanceReportTotals } from "@/model/data/usersBalance/UsersBalanceReportTotals";

export class GetChannelsBalanceReportResData extends ServiceResponseData {
    analizedTransactionsCount: number = 0;
    channelsBalanceReportEntries: ChannelsBalanceReportEntry[] = [];
    channelsBalanceReportTotals: UsersBalanceReportTotals;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.AnalizedTransactionsCount != null) this.analizedTransactionsCount = obj.AnalizedTransactionsCount;

        if (obj.ChannelsBalanceReportEntries && obj.ChannelsBalanceReportEntries.length > 0) {
            this.channelsBalanceReportEntries = [];
            obj.ChannelsBalanceReportEntries.forEach((obj) => {
                var temp = new ChannelsBalanceReportEntry();
                temp.parse(obj);
                this.channelsBalanceReportEntries.push(temp);
            });
        }

        if (obj.ChannelsBalanceReportTotals) {
            var temp = new UsersBalanceReportTotals();
            temp.parse(obj.ChannelsBalanceReportTotals);
            this.channelsBalanceReportTotals = temp;
        }
    }
}
